import { ReactComponent as PlayIcon } from 'assets/icons/play-icon-watch-video.svg';
import * as S from './HowItWorksButton.styled';

type ButtonProps = Omit<
    React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>,
    'onClick'
> & {
    onClick?: () => void;
};

export default function HowItWorksButton({ onClick }: ButtonProps) {
    return (
        <S.Button onClick={onClick}>
            <S.showLP>
                {' '}
                <PlayIcon style={{ width: '19', height: '19' }} />
            </S.showLP>
            <S.hideLP>
                <PlayIcon style={{ width: '25', height: '25' }} />
            </S.hideLP>
            How It Works!
        </S.Button>
    );
}
